import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ConnectionService } from '../../../services/connection/connection.service';
import { LoggerService } from '../../../services/logger/logger.service';
import { map } from 'rxjs/operators';

@Injectable()
export class MailOdooService {

  constructor(
    private connectionService: ConnectionService,
    private logger: LoggerService,
  ) { }

  userMailSubscribe(): Observable<Boolean> {
    const url = '/store/mail/subscribe';
    return this.connectionService.sendJsonPostRequest(url)
      .pipe(map((result: boolean) => {
        if (result) {
          this.logger.info(`MailOdooService: userMailSubscribe ${result}`);
          return true;
        } else {
          this.logger.info(`MailOdooService: userMailSubscribe. Failed.`);
          return false;
        }
      }));
  }

  userMailUnsubscribe(): Observable<Boolean> {
    const url = '/store/mail/unsubscribe';
    return this.connectionService.sendJsonPostRequest(url)
      .pipe(map((result: boolean) => {
        if (result) {
          this.logger.info(`MailOdooService: userMailUnsubscribe ${result}`);
          return true;
        } else {
          this.logger.info(`MailOdooService: userMailUnsubscribe. Failed.`);
          return false;
        }
      }));
  }

  isHashValid(mailHash: string): Observable<Boolean> {
    const url = '/store/mail/hashvalid';
    return this.connectionService.sendJsonPostRequest(url, {
      mailHash: mailHash,
    })
      .pipe(map((result: boolean) => {
        if (result) {
          this.logger.info(`MailOdooService: isHashValid ${result}`);
          return true;
        } else {
          this.logger.info(`MailOdooService: isHashValid. Failed.`);
          return false;
        }
      }));
  }

  hashAction(mailHash: string, subscribe: boolean): Observable<Boolean> {
    const url = '/store/mail/hashaction';
    return this.connectionService.sendJsonPostRequest(url, {
      mailHash: mailHash,
      subscribe: subscribe
    })
      .pipe(map((result: boolean) => {
        if (result) {
          this.logger.info(`MailOdooService: hashAction ${result}`);
          return true;
        } else {
          this.logger.info(`MailOdooService: hashAction. Failed.`);
          return false;
        }
      }));
  }
}
